export const renderTemplate = (template, data) => {
    if (!template.includes("{{")) return template;

    return template.replace(/{{\s*([^}]+)\s*}}/g, (match, key) => {
        try {
            const keys = key.split(".");
            const value = keys.reduce((acc, k) => acc?.[k], data);
            return value !== undefined && value !== null ? value : match; // fallback to original placeholder
        } catch {
            return match; // return placeholder as-is if any error
        }
    });
}